import styled from "@emotion/styled";
import { colorGuide } from "../../theme/colors";

export const TabsContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  background: #fff;
`;

export const TabsWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  position: relative;
`;

export const TabItem = styled.button<{
  isActive: boolean;
  disabled?: boolean;
}>`
  flex: 1;
  padding: 8px 12px;
  color: ${(props) =>
    props.disabled
      ? colorGuide.lightComponents.swipeableTabs.disabled.color
      : props.isActive
      ? colorGuide.lightComponents.swipeableTabs.active.color
      : colorGuide.lightComponents.swipeableTabs.color};
  border: none;
  background: transparent;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
  -webkit-user-select: none;
  border-bottom: ${(props) =>
    props.isActive ? "none" : "0.5px solid #6c6c6c"};
`;

export const InkBar = styled.div`
  position: absolute;
  bottom: 0;
  height: 2px;
  background: ${colorGuide.lightComponents.swipeableTabs.inkBarColor};
  transition: all 0.3s ease-in-out;
`;

export const TabDot = styled.div<{ color: "green" | "red" }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.color === "green" ? "#06C270" : "#BD3F43"};
  margin-right: 4px;
  flex-shrink: 0;
`;
